import {Component, ElementRef, Input, OnInit, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {AbstractControl, FormControl, FormGroup, Validators} from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import {Profile, Right} from '../../../Models/profile';
import { AdminService } from '../../../services/admin.service';
import {AuthenticationService} from '../../../services/authentication.service';
import {MenuItem} from '../../../Models/menuItem';
import {Subject} from 'rxjs';
import {GenericModalService} from '../../../services/generic-modal.service';


@Component({
  selector: 'app-profile-modal',
  templateUrl: './profile-modal.component.html',
  styleUrls: ['./profile-modal.component.css']
})

export class ProfileModalComponent implements OnInit {

  get formData() { return this.profileForm.controls; }

  constructor(
    public bsModalRef: BsModalRef,
    private admService: AdminService,
    private authenticationService: AuthenticationService,
    private modalService: GenericModalService
  ) { }

  @Input() modalTitle: string;

  profileForm: FormGroup;
  objId: number;
  oldProfile: Profile;
  errorMessage = '';
  saveProgress;
  saveSuccess;
  isLoadingEditProfile;

  availableRights: Right[];
  rightColumns = [];
  menu: MenuItem[];
  lastHoveredItems: HTMLElement[];
  selectedRights: Right[];
  selectedMenuItems: MenuItem[];
  irregularMenuItems: MenuItem[];
  hoveredMenuItem: MenuItem;
  hoveredRights: Right[];
  itemSaved: Subject<boolean>;

  @ViewChildren('rightCheckboxes') rightCheckboxes: QueryList<ElementRef>;
  @ViewChildren('checkboxes') checkboxes: QueryList<ElementRef>;

  ngOnInit() {
    this.itemSaved = new Subject();
    this.isLoadingEditProfile = true;
    this.oldProfile = null;
    this.lastHoveredItems = [];
    this.selectedRights = [];
    this.selectedMenuItems = [];
    this.irregularMenuItems = [];
    this.createForm();
    this.loadRights();
    this.loadMenu();
  }


  createForm() {
    this.profileForm = new FormGroup({
      profileId: new FormControl({value: 0, disabled: true}, Validators.required),
      name: new FormControl('', [Validators.required, Validators.maxLength(255)]),
      rights: new FormControl(),
      menuItems: new FormControl(),
      favoritePage: new FormControl()
    } as ProfileControls) as ProfileFormGroup;
  }

  loadRights() {
    this.errorMessage = '';
    this.admService.getRights()
      .subscribe((rights: Right[]) => {
        if (rights) {
          this.availableRights = rights;
          this.rightColumns = [];

          let numberOfItemsPerColumn = Math.ceil(rights.length / 4);

          for (let i = 0; i != rights.length; i++) {
            let column = Math.floor(i / numberOfItemsPerColumn);
            if (!this.rightColumns[column]) {
              this.rightColumns[column] = [];
            }

            this.rightColumns[column].push(rights[i]);
          }
        }
      }, error1 => {
        let err = error1;
        if (error1.indexOf('401') !== -1) {
          err = 'Erro: Sessão expirada.';
        }
        this.errorMessage = err;
      });
  }

  loadMenu() {
    this.errorMessage = '';
    this.admService.getAllMenuItens()
      .subscribe((items: MenuItem[]) => {
        if (items) {
          this.menu = items.map(obj => Object.assign(new MenuItem(), obj));
        }
        if (this.objId !== 0) {
          this.onEdit();
        } else {
          this.isLoadingEditProfile = false;
        }

      }, error1 => this.errorMessage = error1);
  }

  onEdit() {
    this.errorMessage = '';
    this.admService.getProfile(this.objId)
      .subscribe((profile: Profile) => {
        if (profile) {
          this.profileForm.setValue(profile);
          this.oldProfile = Object.assign({}, profile) as Profile;
          this.onEditRights(profile);

          this.selectedMenuItems = profile.menuItems;
          profile.menuItems.forEach(item => {
            let checkBox = this.checkboxes.filter(element => element.nativeElement.id === 'chk_item_' + item.id);
            if (checkBox && checkBox.length == 1) {
              checkBox[0].nativeElement.checked = true;
              this.onCheckMenuItemChild(true, item);
            }
          });
        }
        this.isLoadingEditProfile = false;
      }, error1 => this.errorMessage = error1);

  }

  onEditRights(profile: Profile){
    this.selectedRights = [];
    profile.rights.forEach(right => {
      let r = this.availableRights.filter(a => a.value === right);
      if (r && r.length == 1) {
        this.selectedRights.push(r[0]);
      }
      let checkBox = this.rightCheckboxes.filter(element => element.nativeElement.id === 'chk_right_' + right);
      if (checkBox && checkBox.length == 1) {
        checkBox[0].nativeElement.checked = true;
      }
    });
  }

  onClose() {
    if (!this.saveSuccess){
      this.itemSaved.next(false);
    }
    this.bsModalRef.hide();
  }

  onSave() {
    let alertMessage = '';
    this.errorMessage = '';
    this.saveProgress = true;
    this.saveSuccess = false;

    let profile = this.profileForm.value;
    profile.profileId = this.objId;
    profile.rights = this.selectedRights.map(r => r.value);
    profile.menuItems = this.selectedMenuItems;

    this.getIrregularMenuItems();

    if (profile.rights.length === 0) { // confirmNoRights
      alertMessage = 'O usuário com este perfil não terá acesso ao sistema. Deseja continuar?';
    } else if (this.irregularMenuItems.length > 0) { // preSave
      alertMessage = 'Existem itens de menu selecionados que não correspondem ao direito. Deseja continuar?';
    } else if (profile.menuItems.length === 0) { // confirmEmptyMenu
      alertMessage = 'O usuário com este perfil não terá acesso aos menus do sistema. Deseja continuar?';
    }

    if (alertMessage !== '') {
      const alertNoRights = this.modalService
        .showConfirmModal('Atenção', alertMessage);
      alertNoRights.then((result) => {
        if (result.value) {
          this.save(profile);
        } else {
          this.saveProgress = false;
          this.saveSuccess = false;
        }
      });
    } else {
      this.save(profile);
    }
  }


  save(profile) {
    this.errorMessage = '';
    this.admService.saveProfile(profile, this.oldProfile)
      .subscribe(
        resp => {
          this.saveProgress = false;
          this.saveSuccess = true;
          this.itemSaved.next(true);
        },
        err => {
          let error = err;
          if (err.indexOf('401') !== -1) {
            error = 'Erro: Sessão expirada.';
          }
          this.errorMessage = error;
          this.saveProgress = false;
          this.saveSuccess = false;
        });
  }

  /*   Rights Section  */
  onSelectRight(right: Right) {
    if (!this.selectedRights) {
      this.selectedRights = [];
    }
    let r = this.selectedRights.filter(s => s.value === right.value);

    if (r && r.length === 1) {
      this.selectedRights.splice(this.selectedRights.indexOf(r[0]), 1);
    } else {
      this.selectedRights.push(right);
    }
  }
  /*   End Rights Section  */

  /*   #Menu Section  */
  getLIClass(menuItem: MenuItem) {
    if (this.hasChildren(menuItem) && menuItem.parentId){
      return 'dropdown-submenu dropdown-hover'
    } else if (menuItem.url) {
      return '';
    } else {
      // return `nav-item ${menuItem.children.length > 0 ? 'dropdown dropdown-hover' : 'd-none d-sm-inline-block'}`;
      return `nav-item ${menuItem.children.length > 0 ? 'dropdown' : 'd-none d-sm-inline-block'}`;
    }

  }

  getElementId(menuItem: MenuItem) {
    let id = menuItem.name;
    if (!menuItem.parentId) {
      id += 'Parent'; // ' ' + menuItem.name;
    }
    return id.normalize('NFD').replace(/[\u0300-\u036f( )+]/g, '');
  }

  onCheck(event, item: MenuItem) {
    event.stopPropagation();
    let checkValue = event.currentTarget.checked;
    this.updateChildren(checkValue, item);
    this.onCheckMenuItemChild(checkValue, item);
  }

  updateChildren(checkValue, item: MenuItem){
    if (this.hasChildren(item)){
      item.children.forEach(child => {
        this.updateMenuItemCheckbox(checkValue, child);
        this.updateChildren(checkValue, child);
      });
    }
  }

  onCheckMenuItemChild(checkValue, item: MenuItem) {
    this.updateSelectedMenuItems(checkValue, item);
    if (!checkValue) {
      return;
    }
    if (item.parentId) {
      let parent = this.findMenuItem(this.menu, item.parentId);
      if (parent) {
        this.updateMenuItemCheckbox(checkValue, parent);
        this.onCheckMenuItemChild(checkValue, parent);
      }
    }
  }

  findMenuItem(list, id) {
    for (let i =0; i < list.length; i++) {
      let item = list[i];
      if (item.id === id) {
        return item;
      } else if (this.hasChildren(item)) {
        let child = this.findMenuItem(item.children, id);
        if (child) {
          return child;
        }
      }
    }
    return null;
  }

  updateMenuItemCheckbox(checkValue: boolean, item: MenuItem) {
    let checkBox = this.checkboxes.filter(element => element.nativeElement.id === 'chk_item_' + item.id);
    if ( checkBox && checkBox.length == 1 && (this.isLoadingEditProfile || !checkBox[0].nativeElement.disabled)){
      checkBox[0].nativeElement.checked = checkValue;
      this.updateSelectedMenuItems(checkValue, item);
    }
  }

  updateSelectedMenuItems(checkValue: boolean, item: MenuItem) {
    if (this.hasChildren(item)) { return; }
    const r = this.selectedMenuItems.filter(s => s.id === item.id);
    if (checkValue && r.length == 0) {
      this.selectedMenuItems.push(item);
    } else if (!checkValue && r.length == 1) {
      // se a url for a que estiver nos favoritos, removo
      if (r[0].url === this.profileForm.controls['favoritePage'].value) {
        this.profileForm.patchValue(
          { favoritePage: null }
        );
      }
      // depois removo do vetor de itens selecionados
      this.selectedMenuItems.splice(this.selectedMenuItems.indexOf(r[0]), 1);
    }
  }

  hasMissingRights(item: MenuItem) {
    const isBelowThreshold = (currentValue) => {
      let r = this.selectedRights.filter(s => s.value === currentValue);
      return r && r.length == 1;
    };

    let hasAllRequiredRights = item.requiredRights.every(isBelowThreshold);

    return !hasAllRequiredRights;
  }

  hasAnySelectedDescendentWithMissingRights(item: MenuItem){
    var result = true;
    if (this.hasChildren(item)) {
      item.children.forEach(child => {
        var childHasMissingRights = this.hasMissingRights(child);
        if (!childHasMissingRights) {
          result = false;
        }
        if (!this.hasAnySelectedDescendentWithMissingRights(child)){
          result = false;
        }
      });
    }
    return result;
  }

  hasChildren(item: MenuItem): boolean {
    return item.children && item.children.length > 0;
  }

  hoverRights(item: MenuItem) {
    this.clearHovers();
    this.lastHoveredItems = [];
    this.hoveredRights = [];
    this.hoveredMenuItem = item;

    if (item.requiredRights && item.requiredRights.length > 0){
      item.requiredRights.forEach(right => {
        let labelRight = document.getElementById('label_right_'+right);
        if (labelRight){
          labelRight.classList.add('hovered');
          this.lastHoveredItems.push(labelRight);
        }
        let r = this.availableRights.filter(a => a.value === right);
        if (r && r.length == 1){
          this.hoveredRights.push(r[0]);
        }
      });
    }
  }

  clearHovers() {
    this.hoveredMenuItem = null;
    this.lastHoveredItems.forEach(item => {
      item.classList.remove('hovered');
    });
  }

  getIrregularMenuItems() {
    let irregulars = [];
    this.irregularMenuItems = [];
    const selectedRights = this.selectedRights.map(r => r.value);
    this.selectedMenuItems.forEach(function(menu) {
      const menuRequiredRights = menu.requiredRights;
      const intersectionBetweenRequiredRightsAndSelectedRights = menuRequiredRights.filter(item => selectedRights.includes(item) );
      // console.log('intersectionBetweenRequiredRightsAndSelectedRights', intersectionBetweenRequiredRightsAndSelectedRights);
      if (menuRequiredRights.length !== intersectionBetweenRequiredRightsAndSelectedRights.length) {
        irregulars.push(menu);
      }
    });
    this.irregularMenuItems = irregulars;
  }

  onHeartClick(pageUrl) {
    if (this.formData.favoritePage.value === pageUrl) {
      this.profileForm.patchValue({
        favoritePage: null
      });
    } else {
      this.profileForm.patchValue({
        favoritePage: pageUrl
      });
    }
  }

  checkRelatedCheckbox(checkboxId) {
    const checkBox = this.checkboxes.filter(element => element.nativeElement.id === checkboxId);
    if (checkBox && checkBox.length == 1) {
      return checkBox[0].nativeElement.checked;
    }
  }
  /*   #End Menu Section  */

}

type ProfileControls = { [key in keyof Profile]: AbstractControl };
type ProfileFormGroup = FormGroup & { value: Profile, controls: ProfileControls };

